import React, { createContext, useContext, useState, useMemo } from 'react';

const DeviceContext = createContext(null);

export function DeviceProvider({ children }) {
  const [devices, setDevices] = useState([]);
  const [devicesGps, setDevicesGps] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState();

  const value = useMemo(
    () => ({
      devices,
      setDevices,
      devicesGps,
      setDevicesGps,
      selectedDevice,
      setSelectedDevice,
    }),
    [devices, devicesGps, selectedDevice]
  );

  return <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>;
}

export function useDeviceContext() {
  const context = useContext(DeviceContext);
  if (!context) {
    throw new Error('useDeviceContext deve ser usado dentro de DeviceProvider');
  }
  return context;
}
